import React, { useState, useEffect } from 'react';

const VehicleForm = ({ onSave, editingVehicle, onCancelEdit }) => {
  const initialState = {
    plate: '',
    brand: '',
    model: '',
    year: '',
    color: '',
    currentMileage: '',
    lastService: '',
    status: 'Disponible'
  };

  const [formData, setFormData] = useState(initialState);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (editingVehicle) {
      setFormData(editingVehicle);
    } else {
      setFormData(initialState);
    }
    setErrorMsg("");
  }, [editingVehicle]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.plate || !formData.brand || !formData.model || !formData.year) {
      setErrorMsg("Placa, marca, modelo y año son requeridos");
      return;
    }
    try {
      const result = await onSave(formData);
      if (result && result.error && result.error.includes("placa")) {
        setErrorMsg(result.error);
        return;
      }
      setFormData(initialState); // Clean the form after success
      setErrorMsg("");
      if (editingVehicle && onCancelEdit) onCancelEdit();
    } catch (err) {
      setErrorMsg("Error al guardar el vehículo");
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h3 className="text-lg font-bold mb-4">{editingVehicle ? "Editar Vehículo" : "Registrar Vehículo"}</h3>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Placa</label>
            <input
              type="text"
              name="plate"
              value={formData.plate}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              required
              disabled={!!editingVehicle}
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Marca</label>
            <input
              type="text"
              name="brand"
              value={formData.brand}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Modelo</label>
            <input
              type="text"
              name="model"
              value={formData.model}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Año</label>
            <input
              type="number"
              name="year"
              value={formData.year}
              onChange={handleChange}
              min="1900"
              max={new Date().getFullYear()}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Color</label>
            <input
              type="text"
              name="color"
              value={formData.color}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Kilometraje actual (km)</label>
            <input
              type="number"
              name="currentMileage"
              value={formData.currentMileage}
              onChange={handleChange}
              min="0"
              step="1"
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Fecha último servicio</label>
            <input
              type="date"
              name="lastService"
              value={formData.lastService}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="Disponible">Disponible</option>
              <option value="En taller">En taller</option>
              <option value="En viaje">En viaje</option>
              <option value="Fuera de servicio">Fuera de servicio</option>
            </select>
          </div>
        </div>
        {errorMsg && (
          <div className="mb-2 text-red-600">{errorMsg}</div>
        )}
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          {editingVehicle ? "Guardar Cambios" : "Guardar Vehículo"}
        </button>
        {editingVehicle && (
          <button
            type="button"
            onClick={onCancelEdit}
            className="ml-2 px-4 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-500"
          >
            Cancelar
          </button>
        )}
      </form>
    </div>
  );
};

export default VehicleForm;